import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class RushFieldChange extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.Rush;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        let newPosition = fragment.fieldPosition;
        gameContext.setFieldPosition(newPosition);
        gameContext.setPossessionForTeamId(fragment.rushedBy.teamId);
        gameContext.setCurrentPlayerInPossession(fragment.rushedBy);
    }
}
